
export * from '../../accessibility-settings-state-web/__liferay__/index.js';
